<script setup lang="ts">
import { PropType } from "vue";
import { Task } from "../MTaskList/types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps({
  hidePatientBanner: Boolean,
  item: {
    type: Object as PropType<Task>,
    required: true,
  },
  noScroll: Boolean,
  noPadding: Boolean,
  itemTitle: String,
});
</script>

<template>
  <div class="m-chat-preview">
    <slot name="item:header" v-bind="item" />

    <div class="h-full scroll-area flex-auto full">
      <div class="preview-content">
        <slot v-bind="{ item }" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.m-chat-preview {
  padding-top: 0;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  min-height: 100%;

  .padded-content {
    padding: 16px;
    padding-bottom: 0px;
  }

  .chat-preview-patient-info {
    border-radius: 0;
    border-left: none;
    border-top: none;
    min-height: var(--page-header-height);

    .encounter-patient-info {
      margin-top: 3px;
    }
  }

  .item-header {
    margin-right: 3px;
    border-bottom: 1px solid var(--border-colour);

    padding: 0 1em;

    min-height: 60px;

    .item-title {
      font-family: Georgia;
      font-style: normal;
      font-weight: normal;
      //font-size: 18px;
      line-height: 28px;

      color: var(--text-color);
    }

    .m-select {
      label {
        margin-top: 6px;
      }
    }
  }

  .preview-content {
    overflow: hidden;
    background: var(--grey-lightest);
    flex: 1 1 auto;
    height: 100%;
  }

  .toolbar {
    padding: 0.5rem 0;

    border-bottom: 1px solid #dadde1;

    .maximise-button {
      color: var(--theme-blue);

      .medicus-button {
        font-size: 20px !important;
      }
    }
    .dropdown-options-button {
      color: var(--theme-blue);

      font-size: 22px !important;
    }
    .more-actions-button {
      color: var(--theme-blue);

      .m-icon {
        font-size: 22px !important;
      }
    }
  }
}

.filter-title {
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 125%;

  color: var(--text-color);
}
</style>
